import { render, staticRenderFns } from "./dynamic-comment.vue?vue&type=template&id=fcfff470&scoped=true&"
import script from "./dynamic-comment.vue?vue&type=script&lang=js&"
export * from "./dynamic-comment.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-comment.vue?vue&type=style&index=0&id=fcfff470&prod&lang=scss&"
import style1 from "./dynamic-comment.vue?vue&type=style&index=1&id=fcfff470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfff470",
  null
  
)

export default component.exports